import { Link } from '@mantine/tiptap';
import { TextAlign } from '@tiptap/extension-text-align';
import { Underline } from '@tiptap/extension-underline';
import type { Editor, UseEditorOptions } from '@tiptap/react';
import { useEditor } from '@tiptap/react';
import { StarterKit } from '@tiptap/starter-kit';

export function useTextEditor(editorOptions: Omit<UseEditorOptions, 'extensions'>) {
	return useEditor({
		...editorOptions,
		shouldRerenderOnTransaction: true,
		extensions: [
			StarterKit.configure({
				link: false,
				underline: false,
			}),
			Underline,
			Link,
			TextAlign.configure({ types: ['heading', 'paragraph'] }),
		],
	});
}

export function isTextEditorReady(editor: Editor | null): editor is Editor {
	if (!editor || editor.isDestroyed) {
		return false;
	}

	try {
		editor.can();
		return true;
	} catch (error) {
		if (
			error instanceof TypeError &&
			(error.message.includes("reading 'can'") || error.message.includes("reading 'cached'"))
		) {
			return false;
		}

		throw error;
	}
}

export function getTextEditorHtml(editor: Editor | null): string | null {
	if (!isTextEditorReady(editor)) {
		return null;
	}

	try {
		return editor.getHTML();
	} catch (error) {
		if (error instanceof TypeError && error.message.includes("reading 'cached'")) {
			return null;
		}

		throw error;
	}
}
